<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-pulse-sync"
    [fullScreen]="true"></ngx-spinner>